import { Dispatch } from 'redux';
import {
  LOADING_FAILURE,
  LOADING_REQUEST,
  LOADING_SUCCESS
} from '../../../../../core/redux/types/loading-types';
import { PartnerRepositoryImpl } from '../../../data/repositories/partner-repository-impl';
import { ThreePlPartnerUsecaseImpl } from '../../../domain/usecases/partner-usecase';

import {
  PARTNER_LOAD_REQUEST,
  PARTNER_LOAD_SUCCESS,
  PARTNER_LOAD_FAILURE
} from '../types/partner-type';
import {
  PARTNERS_LOAD_REQUEST,
  PARTNERS_LOAD_SUCCESS,
  PARTNERS_LOAD_FAILURE,
  PARTNERS_UPDATE_PARTNER
} from '../types/partners-type';

export const createPartnerAction = (name: string, hook: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: PARTNER_LOAD_REQUEST });
    try {
      const partnerRepository = new PartnerRepositoryImpl();
      const partnerUsecase = new ThreePlPartnerUsecaseImpl(partnerRepository);

      const result = await partnerUsecase.CreatePartner(name, hook);

      dispatch({ type: PARTNER_LOAD_SUCCESS, payload: result });
      props.history.push('/partners');
    } catch (error) {
      dispatch({ type: PARTNER_LOAD_FAILURE, error });
    }
  };
};

export const getPartnersAction = () => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: PARTNERS_LOAD_REQUEST });
    try {
      const partnerRepository = new PartnerRepositoryImpl();
      const partnerUsecase = new ThreePlPartnerUsecaseImpl(partnerRepository);

      const result = await partnerUsecase.GetPartners();

      dispatch({ type: PARTNERS_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: PARTNERS_LOAD_FAILURE, error });
    }
  };
};

export const editPartnerAction = (partner_id: string, name: string, hook: string, props: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_REQUEST });
    try {
      const partnerRepository = new PartnerRepositoryImpl();
      const partnerUsecase = new ThreePlPartnerUsecaseImpl(partnerRepository);

      const result = await partnerUsecase.EditPartner(partner_id, name, hook);

      dispatch({ type: PARTNER_LOAD_SUCCESS, payload: result });
      dispatch({ type: PARTNERS_UPDATE_PARTNER, partner: result });
      dispatch({ type: LOADING_SUCCESS });
      props.handleClose();
    } catch (error) {
      dispatch({ type: LOADING_FAILURE, error: error });
    }
  };
};

export const getPartnerAction = (partner_id: string) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: PARTNER_LOAD_REQUEST });
    try {
      const partnerRepository = new PartnerRepositoryImpl();
      const partnerUsecase = new ThreePlPartnerUsecaseImpl(partnerRepository);

      const result = await partnerUsecase.GetPartner(partner_id);

      dispatch({ type: PARTNER_LOAD_SUCCESS, payload: result });
    } catch (error) {
      dispatch({ type: PARTNER_LOAD_FAILURE, error });
    }
  };
};
